/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Controls = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11 6.5C11 7.88071 9.88071 9 8.5 9C7.11929 9 6 7.88071 6 6.5C6 5.11929 7.11929 4 8.5 4C9.88071 4 11 5.11929 11 6.5ZM9.5 6.5C9.5 7.05228 9.05228 7.5 8.5 7.5C7.94772 7.5 7.5 7.05228 7.5 6.5C7.5 5.94772 7.94772 5.5 8.5 5.5C9.05228 5.5 9.5 5.94772 9.5 6.5ZM5.03544 6C5.01209 6.1633 5 6.33024 5 6.5C5 6.84749 5.05064 7.18315 5.14494 7.5H2V6H5.03544ZM11.9646 6C11.9879 6.1633 12 6.33024 12 6.5C12 6.84749 11.9494 7.18315 11.8551 7.5H22V6H11.9646ZM18 12.1C18 13.4807 16.8807 14.6 15.5 14.6C14.1193 14.6 13 13.4807 13 12.1C13 10.7193 14.1193 9.59998 15.5 9.59998C16.8807 9.59998 18 10.7193 18 12.1ZM16.5 12.1C16.5 12.6523 16.0523 13.1 15.5 13.1C14.9477 13.1 14.5 12.6523 14.5 12.1C14.5 11.5477 14.9477 11.1 15.5 11.1C16.0523 11.1 16.5 11.5477 16.5 12.1ZM12.0512 11.5C12.0176 11.695 12 11.8954 12 12.1C12 12.4112 12.0406 12.7128 12.1168 13H2V11.5H12.0512ZM18.9488 11.5C18.9824 11.695 19 11.8954 19 12.1C19 12.4112 18.9594 12.7128 18.8832 13H22V11.5H18.9488ZM11 17.8C11 19.1808 9.88071 20.3 8.5 20.3C7.11929 20.3 6 19.1808 6 17.8C6 16.4193 7.11929 15.3 8.5 15.3C9.88071 15.3 11 16.4193 11 17.8ZM9.5 17.8C9.5 18.3523 9.05228 18.8 8.5 18.8C7.94772 18.8 7.5 18.3523 7.5 17.8C7.5 17.2478 7.94772 16.8 8.5 16.8C9.05228 16.8 9.5 17.2478 9.5 17.8ZM5 17.8C5 17.5248 5.03177 17.2569 5.09185 17H2V18.5H5.07001C5.0241 18.2738 5 18.0397 5 17.8ZM12 17.8C12 17.5248 11.9682 17.2569 11.9082 17H22V18.5H11.93C11.9759 18.2738 12 18.0397 12 17.8Z"
                        fill={color}
                    />
                </svg>
        );
    };
